<template>
  <div>
    <b-table :items="history" :fields="fields" striped hover small responsive>
      <template #old="{ item, value }">
        <ul class="list-unstyled" style="word-wrap: anywhere">
          <li
            v-for="(attrValue, index) in flat(value)"
            :key="item.created_at + index"
          >
            <strong>{{ index }}</strong
            >:
            {{ attrValue }}
          </li>
        </ul>
      </template>
      <template #attributes="{ item, value }">
        <ul class="list-unstyled" style="word-wrap: anywhere">
          <li
            v-for="(attrValue, index) in flat(value)"
            :key="item.created_at + index"
          >
            <strong>{{ index }}</strong
            >:
            {{ attrValue }}
          </li>
        </ul>
      </template>
    </b-table>
  </div>
</template>

<script>
import Api from './Api'
import flatten from 'flat'
import { isObject } from 'lodash-es'

export default {
  name: 'History',

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      history: [],
      fields: [
        {
          key: 'user',
          thStyle: {
            width: '10%',
          },
        },
        {
          key: 'date',
          thStyle: {
            width: '10%',
          },
        },
        {
          key: 'description',
          thStyle: {
            width: '15%',
          },
        },
        {
          key: 'old',
        },
        {
          key: 'attributes',
        },
      ],
    }
  },

  mounted() {
    const api = new Api()
    api.getHistory(this.id).then(result => {
      this.history = result.data
    })
  },

  methods: {
    flat(value) {
      if (isObject(value)) {
        return flatten.flatten(value)
      }
      return value
    },
  },
}
</script>
